import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

// Only these airports have seeded data.
const AIRPORTS = [
  { code: 'IST', label: 'IST - Istanbul' },
  { code: 'SJJ', label: 'SJJ - Sarajevo' },
  { code: 'VIE', label: 'VIE - Vienna' },
];

function AirportSelect({ label, field, state, dispatch }) {
  return (
    <TextField
      select
      label={label}
      value={state[field]}
      onChange={(e) =>
        dispatch({ type: 'SET_FIELD', field, value: e.target.value })
      }
      fullWidth
      size='small'
      required
    >
      {AIRPORTS.map((a) => (
        <MenuItem key={a.code} value={a.code}>
          {a.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default function RouteSection({ state, dispatch }) {
  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <AirportSelect label='Departure from' field='departureFrom' state={state} dispatch={dispatch} />
        <AirportSelect label='Departure to' field='departureTo' state={state} dispatch={dispatch} />
      </Stack>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mt: 1 }}>
        <AirportSelect label='Return from' field='returnFrom' state={state} dispatch={dispatch} />
        <AirportSelect label='Return to' field='returnTo' state={state} dispatch={dispatch} />
      </Stack>
    </Box>
  );
}
